import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Colors } from "../../utils/colors";
import {
  toggleOnboardingFlow,
  getAccountSlice,
  getIncompleteOnboardingFlows,
} from "../../redux/slices/accountSlice";
import {
  getNotificationState,
  notificationActions,
} from "../../redux/slices/notificationSlice";
import RectangleButton from "../Buttons/RectangleButton";
import ConfirmActionModal from "../Containers/ConfirmPopups/ConfirmActionModal";

// Mounted within App.tsx so it survives navigation between top-level routes.
// Shows the current onboarding step the user is on.
const OnboardingTourStepIndicator = () => {
  const dispatch = useDispatch();
  const { accountData } = useSelector(getAccountSlice);
  const incompleteOnboardingFlows = useSelector(getIncompleteOnboardingFlows);
  const { currentTourStep } = useSelector(getNotificationState);
  const [showSkipConfirm, setShowSkipConfirm] = useState(false);

  const hasIncompleteFlow =
    !!currentTourStep &&
    incompleteOnboardingFlows.some(
      (flow) => flow.id === currentTourStep.flowType
    );

  if (
    !currentTourStep ||
    !hasIncompleteFlow ||
    !currentTourStep.hasBeenVisible ||
    currentTourStep.isStepVisible ||
    currentTourStep.hideStepIndicator
  ) {
    return null;
  }

  const confirmedSkipOnPress = () => {
    dispatch(
      toggleOnboardingFlow(
        accountData.uid,
        currentTourStep.flowType,
        true,
        true
      )
    );
    dispatch(
      notificationActions.clearCurrentTourStep({
        flowType: currentTourStep.flowType,
      })
    );
  };

  return (
    <>
      <div
        className="AlignedRow"
        style={{
          position: "fixed",
          bottom: 20,
          left: 20,
          gap: 14,
          paddingBlock: 14,
          paddingInline: 20,
          backgroundColor: Colors.WHITE,
          borderRadius: 20,
          boxShadow: "-3px 7px 25px 1px #0000004d",
          zIndex: 10000,
        }}
      >
        <span className="smallBodySubtext" style={{ whiteSpace: "nowrap" }}>
          {currentTourStep.totalSteps
            ? `${currentTourStep.stepNumber} of ${currentTourStep.totalSteps}`
            : `Step ${currentTourStep.stepNumber}`}
        </span>
        <RectangleButton
          buttonLabel="Skip tour"
          onPress={() => setShowSkipConfirm(true)}
          altColor={Colors.WHITE1}
          altTextColor={Colors.BLACK}
          altPaddingVert={10}
          altPaddingHorz={14}
          containerStyles={{
            color: Colors.BLACK,
            cursor: "pointer",
            whiteSpace: "nowrap",
            border: `0.5px solid ${Colors.GRAY2}`,
          }}
        />
      </div>
      <ConfirmActionModal
        heading="Skip and end this tour?"
        subtext="You can revisit this tour by restarting it via the home page."
        confirmButtonText="Skip Tour"
        hideModal={!showSkipConfirm}
        setIsVisible={setShowSkipConfirm}
        confirmOnPress={confirmedSkipOnPress}
      />
    </>
  );
};

export default OnboardingTourStepIndicator;
